import { render, staticRenderFns } from "./guessing-item.vue?vue&type=template&id=4b7a9cfa&scoped=true&"
import script from "./guessing-item.vue?vue&type=script&lang=js&"
export * from "./guessing-item.vue?vue&type=script&lang=js&"
import style0 from "./guessing-item.vue?vue&type=style&index=0&id=4b7a9cfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a9cfa",
  null
  
)

export default component.exports